import { render, staticRenderFns } from "./PageNotFoundIndex.vue?vue&type=template&id=afaf4e74&scoped=true&"
import script from "./PageNotFoundIndex.vue?vue&type=script&lang=js&"
export * from "./PageNotFoundIndex.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFoundIndex.vue?vue&type=style&index=0&id=afaf4e74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaf4e74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VBtn,VContainer,VIcon,VMain})
